import React from 'react'
import FrameAgreementListPage from './FrameAgreementListPage'
import CreateFrameAgreementPage from './CreateFrameAgreementPage'
import FrameAgreementDetailPage from './FrameAgreementDetailPage'

const FrameAgreementRoutes = [
  {
    breadcrumb: 'Frame Agreement List',
    path: '',
    element: <FrameAgreementListPage />,
    children: [],
  },
  {
    breadcrumb: 'Create Frame Agreement',
    path: 'create',
    element: <CreateFrameAgreementPage />,
  },
  {
    breadcrumb: 'Frame Agreement Detail',
    path: ':id',
    element: <FrameAgreementDetailPage />,
  },
]

export default FrameAgreementRoutes
